import React from "react";
import Modal from "react-modal";
import Button from "../../formElements/button/Button";
import "./popupModal.css";
const customStyles = {
  content: {
    zIndex: 2,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: "300px",
    maxWidth: "500px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    border: "none",
    overflow: "hidden",
  },
};

Modal.setAppElement("#modal");

const Modals = ({
  isOpen = false,
  closeModal,
  error,
  children,
  title,
  btnDark,
  btnOutline,
  styles,
  onBackdropClick = false,
}) => {
  const mergedStyles = {
    content: {
      ...customStyles.content,
      ...styles?.content,
    },
  };

  return (
    <div>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          onRequestClose={!onBackdropClick && closeModal}
          style={mergedStyles}
          contentLabel="Example Modal"
        >
          {title && (
            <div className="text-center mt-2">
              <span className="font-weight-bold">{title}</span>
            </div>
          )}

          {/*Buttons*/}
          {children}
          {btnDark || btnOutline ? (
            <div>
              {btnDark && (
                <Button
                  onClick={btnDark?.onclick}
                  className="text-center mx-auto w-75 h-50 content-center mb-3"
                  style={{
                    backgroundColor: "var(--primary-color)",
                  }}
                  label={btnDark?.label}
                  disabled={btnDark?.disabled}
                ></Button>
              )}
              {btnOutline && btnOutline.label && (
                <Button
                  type="outline"
                  onClick={btnOutline?.onclick}
                  className="text-center mx-auto w-75 h-50 content-center"
                  label={btnOutline?.label}
                ></Button>
              )}
            </div>
          ) : null}
          {error && <h5>{error}</h5>}
        </Modal>
      )}
    </div>
  );
};

export default Modals;
